import { config as edgeConfig } from "mocks/data/edgeConfig/capriolo";
import {create} from "mocks/data/maps/capriolo/create.js";
import { Farm } from "types/Farm";


export function buildFarmVirtual(): Farm {
	const farm: Farm = {
		id: 0,
		name: "VIRTUAL",
		farmCode: "VIRTUAL",

		country: "Italy",
		address: "",
		zipCode: "",
		airportCode: "",
		timezone: "Europe/Rome",

		defaultWorkingDayTime: 8,
		defaultNumberOfWorkers: 5,
		defaultWorkingDayTotalMinutes: 2400,

		edgeServicesConfig: edgeConfig,
		edgeServicesEnabled: true,
		mapConfig: create(),
		growUnits: [],

		externalLinks: []
	}

	return farm;
}

